// Import React and necessary hooks
import React from "react";
// Import CSS for footer styling
import "../../css/Footer.css";
// Import SVG icons for phone and location/email
import { ReactComponent as PhoneIcon } from "../../assets/icons/call.svg";
import { ReactComponent as LocationIcon } from "../../assets/icons/email.svg";
// Import Link and useNavigate for navigation
import { Link, useNavigate } from "react-router-dom";

/**
 * Footer component for displaying contact information and legal notices.
 *
 * Sections:
 * - Contact section: Email, phone, contact link, privacy policy link
 * - Legal section: Regulatory and company information
 */
function Footer() {
  const navigate = useNavigate();
  return (
    <footer className="footer">
      {/* Contact Footer Section */}
      <div className="footer-contact-section">
        <div className="footer-contact-info">
          {/* Email Contact */}
          <div className="footer-contact-item">
            <div className="footer-contact-icon">
              <LocationIcon />
            </div>
            <div className="footer-contact-details">
              <a
                href="mailto:gurmeet@oakmontfinancialservices.co.uk"
                className="content-large footer-contact-value"
              >
                gurmeet@oakmontfinancialservices.co.uk
              </a>
            </div>
          </div>
          {/* Phone Contact */}
          <div className="footer-contact-item">
            <div className="footer-contact-icon">
              <PhoneIcon />
            </div>
            <div className="footer-contact-details">
              <a
                href="tel:07970 818078"
                className="content-large footer-contact-value"
              >
                07970 818078
              </a>
            </div>
          </div>
          {/* Contact Us Link */}
          <div className="footer-contact-item">
            <div className="footer-contact-details">
              <Link
                to="/contact"
                className="content-large footer-contact-value"
                style={{ textDecoration: "underline" }}
              >
                Send Us A Message
              </Link>
            </div>
          </div>
          {/* Privacy Policy Link */}
          <div className="footer-contact-item">
            <div className="footer-contact-details">
              <Link
                to="/privacy-policy"
                className="content-large footer-contact-value"
                style={{ textDecoration: "underline" }}
              >
                Privacy Policy
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Legal Footer Section */}
      <div className="content-tiny footer-legal">
        {/* Regulatory and company information */}
        <p>
          Oakmont Financial Services is a trading style of Gurmeet Singh Kler,
          which is an Appointed Representative of Rosemount Financial Solutions
          (IFA) Ltd which is authorised and regulated by the Financial Conduct
          Authority (FCA).  Entered on the FCA Register
          (https://register.fca.org.uk/) under reference 535515.   
        </p>
        <p>
          Registered as a Limited Company in England & Wales No
          05668905. Registered Address: Rosemount House, 2-4 Chequers Road,
          Basingstoke, RG21 7PU.
        </p>
        {/* Complaints procedure link */}
        <p className="content-tiny-semibold">
          The information contained within this website is subject to the UK
          regulatory regime, and is therefore targeted at consumers based in the
          UK. For complaints, please{" "}
          <span
            onClick={() => navigate("/contact#complaints-procedure")}
            style={{
              textDecoration: "underline",
              color: "inherit",
              cursor: "pointer",
            }}
          >
            click here
          </span>
          .
        </p>
      </div>
    </footer>
  );
}

// Export the Footer component as default
export default Footer;
